import { Box, Typography } from '@mui/material';
import { BRIDGE_STATUS_COLORS } from '../../../../../helpers/googleAdsBridgesConstants';

export const IngestRunsSummary = ({ summary, error }) => {
  if (error) {
    return <Typography variant="body2" sx={{ px: 2 }}>Summary unavailable</Typography>;
  }
  if (!summary || !summary.bridges || !summary.bridges.length) return null;

  return (
    <Box sx={{ px: 2, pb: 1 }}>
      {summary.bridges.map((bridge) => (
        <Typography variant="body2" key={bridge.bridge_id}>
          <b>{bridge.account_name}</b>
          {!bridge.enabled && ' (disabled)'}
          {' · last ok: '}
          {bridge.last_ok_at ? new Date(bridge.last_ok_at).toLocaleString() : 'never'}
          {' · errors 24h: '}
          <span style={bridge.errors_24h > 0 ? { color: BRIDGE_STATUS_COLORS.RED } : undefined}>
            {bridge.errors_24h}
          </span>
        </Typography>
      ))}
    </Box>
  );
};
